import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQItemm from './FAQItemm';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Morachichincholischoolpicnic() {



    const cardData =
    {
        keyword: 'Morachi Chincholi School Picnic',
        heading: 'Anand Krushi Paryatan Kendra: Morachi Chincholi School Picnic',
        headingDescription: 'Planning an educational yet fun-filled Morachi Chincholi school picnic? Anand Krushi Paryatan Kendra, just 55 km from Pune, is the perfect destination for students to connect with nature, learn about rural life, and enjoy a full day of safe outdoor activities in a serene, eco-friendly environment. Ideal for schools and educational groups, the picnic includes traditional and adventure-based activities such as bullock cart and tractor rides, boating, swimming, horse riding, and an exciting rain dance zone. Students are also entertained with puppet shows, magic performances, and traditional village games that promote cultural learning and teamwork.',

        top: 'Top Activities at Anand Krushi Paryatan Kendra:',
topPlaces: [
  {
    "title": "Anand Krushi Paryatan – School Picnic Delight",
    "description": "Designed for school outings, this package includes a full day of rural adventure: bullock-cart and tractor rides, peacock spotting, traditional games like lagori and kho-kho, puppet/magic shows, and splash pool fun. Students enjoy nutritious meals—breakfast, unlimited Maharashtrian lunch, and evening snacks. Safe, clean, and guided by trained staff, it’s ideal for kids of all age groups. Teachers get complimentary meals and separate seating arrangements."
  },
  {
    "title": "Mauli Krushi Paryatan – Nature & Learning Combo",
    "description": "Perfect for educational trips, Mauli Krushi offers farming tours, cow milking demos, compost-making activities, and interactive animal feeding. The day also includes games, slides, a rain dance session, and a playground for younger students. A wholesome Maharashtrian thali and welcome drink are provided, and group seating ensures ease of supervision. Excellent for experiential learning and rural immersion."
  },
  {
    "title": "Mhalasakant Agro Tourism – Adventure & Fun Zone",
    "description": "This destination offers an exciting blend of fun and farming. Kids love the adventure zone—zip line, archery, rope bridge, and balancing games—alongside farming demos, birdwatching, and storytelling sessions. The picnic includes breakfast, lunch, and high tea. Magic and puppet shows are scheduled mid-day. Staff-to-student ratio is carefully maintained for safety. Group booking discounts available."
  },
  {
    "title": "Jay Malhar Krushi Paryatan – High-Energy School Package",
    "description": "For schools seeking a dynamic day, Jay Malhar includes 45+ activities in one package—rain dance, pool time, trampoline, slides, kabaddi, tug of war, and seasonal hurda parties. A popular choice for larger schools, it offers enough space, shade, and staff for smooth coordination. Meals are tailored for kids, and a mini market allows souvenir purchases. Optional guide-led farm walk available."
  },
  {
    "title": "Mayur Agro Tourism – Learning in Nature",
    "description": "Great for pre-primary and primary school picnics, Mayur Agro focuses on simplicity and hands-on experiences. Activities include seed planting, pottery, diya painting, and bullock-cart rides. Their clean, enclosed play area ensures safe fun for small kids. Healthy meals served on banana leaves give students a taste of traditional hospitality. The space also includes a craft corner and shaded rest areas."
  }
],




  "services": [
    {
      "name": "Educational Farm Tours for Schools",
      "description": "Students participate in interactive farm tours led by experienced agronomists—covering crop cycles, organic practices, composting, and hands-on activities like seed sowing and vegetable harvesting."
    },
    {
      "name": "Bird Sanctuary Picnic for Students",
      "description": "Enjoy school picnics adjacent to bird-rich zones with guided birdwatching sessions—spot peacocks, waterfowl, and native species while learning about their habitat and ecology."
    },
    {
      "name": "Nature Trails and Farming Activities",
      "description": "Curated nature walks along farm trails combined with farming demonstrations—students explore biodiversity, plant identification, soil health, and seasonal planting techniques."
    },
    {
      "name": "Safe and Guided School Tours",
      "description": "All school outings include certified guides, first-aid staff, safety briefings, dedicated staff-student ratios, and secure supervision to ensure a worry-free educational day out."
    },
    {
      "name": "Kids Play Zones and Outdoor Games",
      "description": "Child-safe play areas with swings, slides, mud-play zones, and traditional games like sack race, tug‑of‑war, and relay races—designed for both fun and teamwork."
    },
    {
      "name": "Lunch and Snack Packages for Students",
      "description": "School-friendly, hygienic meal plans including nutritious lunches, mid-day snacks, and hydration—catered to dietary needs and served in clean picnic or dining zones."
    },
    {
      "name": "Fun and Learning Combo Picnics",
      "description": "Balanced programs that mix engaging educational workshops with playful segments—science demos, cultural skits, craft sessions, alongside farm activity breaks."
    },
    {
      "name": "Day Stay Options for School Groups",
      "description": "Facilities available for full-day stays—covering lunch, twice daily snacks, rest areas, indoor-outdoor mix, and structured timing to match school schedules."
    },
    {
      "name": "Bullock Cart and Rural Games",
      "description": "Traditional bullock cart rides and village-style games such as coconut races, pottery experiences, and grain-grinding demos for immersive rural exposure."
    },
    {
      "name": "School Transport Arrangements",
      "description": "Assistance arranging safe bus or van transport from school to the farm and back, with route planning, timing coordination, and drop-off supervision."
    },
    {
      "name": "Group Discounts for School Picnics",
      "description": "Special per-student rates and cost-saving packages for large school groups, with flexible add-ons and complimentary teacher chaperone benefits."
    },
    {
      "name": "Certified Picnic Spot for Schools",
      "description": "Designated educational site approved by school boards—equipped with child-safe facilities, sanitary restrooms, shaded areas, and compliance with safety standards."
    },
    {
      "name": "Cultural Education Experience",
      "description": "Programs introducing local traditions—folk songs, village crafts, indigenous lifestyle talks, and mehendi/warli art sessions—bringing Maharashtra’s heritage alive for students."
    },
    {
      "name": "Eco‑Tourism for Kids",
      "description": "Engaging outdoor eco-programs including tree-planting, compost making, insect spotting labs, and eco-awareness sessions tailored for young minds."
    },
    {
      "name": "Workshops for School Students",
      "description": "Hands-on workshops on topics like pottery, organic gardening, crop-processing, and sustainable crafts—supporting curriculum-based experiential learning."
    }
  ],
  "tableData": [
    ["Educational Farm Tours for Schools", "Bird Sanctuary Picnic for Students"],
    ["Nature Trails and Farming Activities", "Safe and Guided School Tours"],
    ["Kids Play Zones and Outdoor Games", "Lunch and Snack Packages for Students"],
    ["Fun and Learning Combo Picnics", "Day Stay Options for School Groups"],
    ["Bullock Cart and Rural Games", "School Transport Arrangements"],
    ["Group Discounts for School Picnics", "Certified Picnic Spot for Schools"],
    ["Cultural Education Experience", "Eco‑Tourism for Kids"],
    ["Workshops for School Students", ""]
  ],



"whychoose": [
  {
    "WhyChooseheading": "Tailored School Picnic Packages",
    "WhyChoosedescription": "Mauli Krushi Paryatan Kendra offers customized school picnic packages with activities like nature walks, bird watching, and traditional games, ensuring an educational and enjoyable experience for students."
  },
  {
    "WhyChooseheading": "Engaging Outdoor Activities",
    "WhyChoosedescription": "Students can participate in various outdoor activities such as bullock cart rides, tractor tours, zip-lining, and archery, promoting teamwork and physical fitness in a natural setting."
  },
  {
    "WhyChooseheading": "Comfortable Accommodation Options",
    "WhyChoosedescription": "The center provides comfortable accommodation options, including cottages and dormitories, equipped with modern amenities to ensure a pleasant stay for school groups."
  },
  {
    "WhyChooseheading": "Cultural and Culinary Experiences",
    "WhyChoosedescription": "Students can experience authentic Maharashtrian cuisine and cultural activities, enhancing their understanding of local traditions and fostering cultural appreciation."
  },
  {
    "WhyChooseheading": "Eco-Friendly and Peaceful Environment",
    "WhyChoosedescription": "Situated in a pollution-free zone, the campsite promotes well-being and a healthy lifestyle, offering a serene environment free from noise and pollution, perfect for relaxation and rejuvenation."
  },
  {
    "WhyChooseheading": "Convenient Location Near Pune",
    "WhyChoosedescription": "Located approximately 55 km from Pune, Mauli Krushi Paryatan Kendra is easily accessible, making it an ideal destination for a quick getaway to experience nature and rural life."
  }
]

































    }

const faqData = [
  {
    id: 'FAQ1',
    question: 'Is Morachi Chincholi a good location for a school picnic?',
    answer: 'Yes, Morachi Chincholi is a safe, educational, and nature-rich destination ideal for school picnics from Pune and nearby areas.',
  },
  {
    id: 'FAQ2',
    question: 'What activities are included in a school picnic at Morachi Chincholi?',
    answer: 'Activities include peacock watching, bullock cart rides, tractor rides, nature trails, traditional games, and farm learning experiences.',
  },
  {
    id: 'FAQ3',
    question: 'Is the picnic suitable for primary and secondary school students?',
    answer: 'Yes, the location is child-friendly and suitable for students of all age groups, including pre-primary to secondary levels.',
  },
  {
    id: 'FAQ4',
    question: 'Are meals and snacks provided during the school picnic?',
    answer: 'Yes, school picnic packages generally include breakfast, lunch (traditional Maharashtrian food), and evening snacks or juice.',
  },
  {
    id: 'FAQ5',
    question: 'What safety measures are in place for school children?',
    answer: 'Organizers ensure a secure environment with supervision, first aid, safe play zones, and staff trained to handle school groups.',
  },
  {
    id: 'FAQ6',
    question: 'Is there space for group games and team-building activities?',
    answer: 'Yes, large open fields are available where group games, team activities, and even small competitions can be conducted.',
  },
  {
    id: 'FAQ7',
    question: 'Do they provide guides or coordinators for school groups?',
    answer: 'Yes, most resorts or agro-tourism centers assign coordinators to guide school children through scheduled activities and ensure smooth flow.',
  },
  {
    id: 'FAQ8',
    question: 'Is transportation arranged for school picnics?',
    answer: 'Many resorts assist with transportation arrangements or work with schools to coordinate buses from Pune and surrounding areas.',
  },
  {
    id: 'FAQ9',
    question: 'What is the ideal group size for a school picnic here?',
    answer: 'Group sizes of 40 to 150 students are easily accommodated, and discounts are often provided for larger groups.',
  },
  {
    id: 'FAQ10',
    question: 'How far is Morachi Chincholi from Pune?',
    answer: 'Morachi Chincholi is approximately 60–65 km from Pune and can be reached in about 1.5 to 2 hours by bus or private transport.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mrs. Meenal Joshi, School Teacher, Pune',
    feedback: "Our school picnic at Morachi Chincholi was extremely well-managed. Kids had fun while learning about nature and rural life.",
    rating: 5,
  },
  {
    id: 2,
    name: 'Mr. Anil Kulkarni, Principal, PCMC',
    feedback: "We take our students to Morachi Chincholi every year. It's safe, engaging, and gives students a refreshing outdoor experience.",
    rating: 5,
  },
];



































    const carouselItems = testimonials.map(testimonial => (
        <div key={testimonial.name}>
            <blockquote>

                <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
                <footer className=' user'>— {testimonial.name}</footer>
            </blockquote>
        </div>
    ));

    const carouselOptions = {
        loop: true,
        margin: 10,
        nav: true,
        items: 1
    };

    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9689125047",
            "+91 9623755047",
            "+91 9673132497",


        ],
        email: "thopatemala@gmail.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "One Day Picnic Spot Near Pune for Family",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "One Day Trip Near Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Picnic Spot Near Pune ",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Picnic Destination Near Pune ",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Corporate Outing Resorts Near Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Agri Tourism Near Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Destination Wedding Near Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Hurda Party Places Near Pune",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Water Park Near Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "School Picnic Spots Near Pune for Students",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "One Day Adventure Resorts Near Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Resort Near Pune ",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Forest Resorts Near Pune ",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Nature resorts near pune for weekend",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mango Mahotsav in Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Krushi Paryatan Kendra near Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Camping Places Near Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Activities Resort Near Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Agro Tourism Near Mumbai for Family",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "One Day Picnic Spot From Mumbai",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "One Day Picnic Packages Near Mumbai",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "School Picnic Spots in Mumbai",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Resort Near Mumbai ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Team Outing Places Near Mumbai",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Corporate Outing Near Mumbai",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Picnic Spot Near Nashik",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Farm House On Rent in Pune ",
        },
    ];


    const images = [
        { src: "/images/gallery/01.jpg", alt: "Image 1" },
        { src: "/images/gallery/02.jpg", alt: "Image 1" },
        { src: "/images/gallery/03.jpg", alt: "Image 1" },
        { src: "/images/gallery/04.jpg", alt: "Image 1" },
        { src: "/images/gallery/05.jpg", alt: "Image 1" },
        { src: "/images/gallery/06.jpg", alt: "Image 1" },
        { src: "/images/gallery/07.jpg", alt: "Image 1" },
        { src: "/images/gallery/08.jpg", alt: "Image 1" },
        { src: "/images/gallery/09.jpg", alt: "Image 1" },
        { src: "/images/gallery/010.jpg", alt: "Image 1" },
        { src: "/images/gallery/011.jpg", alt: "Image 1" },
        { src: "/images/gallery/012.jpg", alt: "Image 1" },

    ];


const schoolPicnicSchema = {
  "@context": "https://schema.org",
  "@type": "EducationalOccupationalProgram",
  "name": "Morachi Chincholi School Picnic",
  "educationalProgramMode": "OnSite",
  "description": "Plan a fun-filled and educational school picnic to Morachi Chincholi. Activities include bird sanctuary visits, nature trails, farming demonstrations, bullock cart rides, rural games, eco-tourism workshops, and more. Safe and guided experiences for students with food and transport packages.",
  "provider": {
    "@type": "Organization",
    "name": "Anand Krushi Paryatan Kendra",
    "sameAs": "https://morachichincholi.in/"
  },
  "programPrerequisites": "School groups, prior booking required",
  "hasCourse": [
    {
      "@type": "Course",
      "name": "Farm and Nature Tour",
      "description": "Interactive sessions on farming, bullock cart rides, and nature walk."
    },
    {
      "@type": "Course",
      "name": "Eco-Education Workshop",
      "description": "Fun, educational workshops on ecology and sustainability for kids."
    }
  ],
  "url": "https://morachichincholi.in/school-picnic"
};



    return (
        <div>
<Helmet>
  <title>Morachi Chincholi School Picnic | Educational Farm Tours & Student Activities</title>
  <meta 
    name="description" 
    content="Organize a memorable and educational school picnic to Morachi Chincholi. Includes bird sanctuary tours, nature walks, farming experiences, bullock cart rides, play zones, meals, and certified safe student outings." 
  />
  <meta 
    name="keywords" 
    content="Educational farm tours for schools, Bird sanctuary picnic for students, Nature trails and farming activities, Safe and guided school tours, Kids play zones and outdoor games, Lunch and snack packages for students, Fun and learning combo picnics, Day stay options for school groups, Bullock cart and rural games, School transport arrangements, Group discounts for school picnics, Certified picnic spot for schools, Cultural education experience, Eco-tourism for kids, Workshops for school students" 
  />
  <script type="application/ld+json">
    {JSON.stringify(schoolPicnicSchema)}
  </script>
</Helmet>
            <section className="breadcrumb-main pb-20 pt-14" style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}>
                <div className="section-shape section-shape1 top-inherit bottom-0" style={{ backgroundImage: 'url(images/shape8.png)' }}></div>
                <div className="breadcrumb-outer">
                    <div className="container">
                        <div className="breadcrumb-content text-center">
                            <h1 className="mb-3"> {cardData.keyword}</h1>

                        </div>
                    </div>
                </div>
                <div className="dot-overlay"></div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/41.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#609F31', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 darkcolor'> Why Choose Anand Krushi Paryatan Kendra for {cardData.keyword + " Rates"}</h3>
                            {/* <BusRatesTable /> */}

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 darkcolor"> {item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">fAQS {cardData.keyword} For Anand Krushi Paryatan Kendra</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                {faqData.map((faq) => (
                                                    <FAQItemm key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <div>

                                <div className="contact-box Borderr">
                                    <h3 className='darkcolor'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Gallery</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image py-1"

                                            />
                                        </div>
                                    ))}
                                    {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #609F31',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#609F31' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2 text-white"></i>
                                            <div className=''>
                                                <a href="tel:+919689125047" className="d-block  text-white">+91 9689125047</a>
                                                <a href="tel:+919623755047" className="d-block  text-white">+91 9623755047</a>
                                                <a href="tel:+919673132497" className="d-block  text-white">+91 9673132497</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <i className="bi bi-envelope fs-1 mb-2 text-white"></i>
                                                <a href="mailto:thopatemala@gmail.com" className=" text-white d-block">
                                                    thopatemala@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <i className="bi bi-house-fill fs-1 mb-2 text-white"></i>
                                                <p className="whit text-white ">
                                                    <i> Anand Krushi Paryatan Kendra <br />
                                                        Dattatraya Anandrao Thopate, Topate Vasti, Chincholi Morachi, Tal. Shirur, Dist. Pune. Maharashtra - 412218

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Morachichincholischoolpicnic;